define( [
	"./document"
], function( document ) {
	return document.documentElement;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/documentElement.js
// module id = 293
// module chunks = 0